
// 判断是否为空
function is_empty(data){
    if(data === '' || data === null || data === undefined || data.length == 0){
        return true
    }else{
        return false
    }
}   

export default is_empty